<template>
  <div class="menu d-flex flex-column justify-content-between">
    <div>
      <a href="/company" class="logo">
        <img src="@/assets/images/logo.jpg" />
      </a>
      <MenuItems :menuSelected="this.menuSelected" />
    </div>
    <div class="iris_logo">
      <img src="@/assets/images/logo_iris.png" style="width: 50%" />
    </div>
  </div>
</template>
<script>
import utils from "@/plugins/utils.js";
import MenuItems from "@/components/company/customer/MenuItems.vue";
import Cookies from "js-cookie";

export default {
  name: "MenuDesktop",
  props: {
    company: Object,
    menuSelected: {
      dashboard: false,
      beneficiaries: false,
      orders: false,
      deliveryPoints: false,
      newOrder: false,
      faq: false,
      account: false,
      contact: false,
      terms: false,
      gdpr: false,
      companySearch: false,
    },
  },
  data() {
    return {
      customer: null,
    }
  },
  components: {
    MenuItems
  },
  methods: {
    logout() {
      utils.logout();
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
  created() {
    if (this.company == null) {
      this.customer =  JSON.parse(sessionStorage.getItem("selectedCompany"));
      // this.customer = Cookies.getJSON("selectedCompany");
    } else {
      this.customer = this.company;
    }
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
